type FormCheckGroupProps = {
  children: React.ReactNode;
  formLabel: React.ReactNode;
};

const FormCheckGroup = ({ children, formLabel }: FormCheckGroupProps) => {
  return (
    <div>
      <div>{formLabel}</div>
      {children}
    </div>
  );
};

export default FormCheckGroup;
